/**
 * Icon Size Standards for Mobile UI
 * 
 * Standardized icon sizes for consistent mobile app styling
 * Use these constants or Tailwind classes for icon sizing
 */

export const ICON_SIZES = {
  // Small icons (in cards, inline with text)
  small: {
    size: 12,        // 12px
    className: 'w-3 h-3',
    usage: 'Inline with small text, checkmarks in timelines',
  },
  // Medium icons (in buttons, secondary actions)
  medium: {
    size: 16,        // 16px
    className: 'w-4 h-4',
    usage: 'Card footer icons, status indicators',
  },
  // Default icons (in buttons, primary actions)
  default: {
    size: 20,        // 20px
    className: 'w-5 h-5',
    usage: 'Button icons, action buttons',
  },
  // Large icons (in navigation)
  large: {
    size: 24,        // 24px
    className: 'w-6 h-6',
    usage: 'Bottom navigation, app bar icons',
  },
  // Extra large icons (featured, hero)
  xlarge: {
    size: 32,        // 32px
    className: 'w-8 h-8',
    usage: 'Featured icons, hero sections',
  },
};

/**
 * Get icon size class for Tailwind
 */
export const getIconSizeClass = (size = 'default') => {
  return ICON_SIZES[size]?.className || ICON_SIZES.default.className;
};

/**
 * Get icon size number for lucide-react size prop
 */
export const getIconSize = (size = 'default') => {
  return ICON_SIZES[size]?.size || ICON_SIZES.default.size;
};

export default ICON_SIZES;

